import { Component } from '@angular/core';
import {HeroSectionComponent} from "../app-persona/hero-section/hero-section.component";
import {TeamHomeComponent} from "../team-home/team-home.component";
import {TopBarComponent} from "../top-bar/top-bar.component";
import {HeroEnterpriseComponent} from "./home/hero-enterprise/hero-enterprise.component";
import {ValueEmpresarialComponent} from "./home/value-empresarial/value-empresarial.component";
import {InfluenciaEmpresaComponent} from "./home/influencia-empresa/influencia-empresa.component";
import {MenuSafeJobComponent} from "./home/menu-safe-job/menu-safe-job.component";
import {FrecuentlyQuestionsComponent} from "./home/frecuently-questions/frecuently-questions.component";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-app-empresa',
  standalone: true,
  imports: [
    HeroSectionComponent,
    TeamHomeComponent,
    TopBarComponent,
    HeroEnterpriseComponent,
    ValueEmpresarialComponent,
    InfluenciaEmpresaComponent,
    MenuSafeJobComponent,
    FrecuentlyQuestionsComponent,
    RouterOutlet
  ],
  templateUrl: './app-empresa.component.html',
  styleUrl: './app-empresa.component.css'
})
export class AppEmpresaComponent {

}
